import moment from 'moment';

// @vue/component
export default {
  name: 'ShRecordPlayer',

  props: {
    audioSourcePath: {
      type: String,
      default: null,
    },
    autoPlay: {
      type: Boolean,
      default: false,
    },
    canDownload: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      playerVolume: 100,
      linkToRecord: null,
      audioInstance: null,
      allDuration: '---',
      playerState: 'stop',
      playerSliderWidth: 0,
      currentDuration: '---',
      isPlayerDisabled: true,
      playerVolumeCache: 100,
      isMessageVisible: false,
      currentBuffer: 0,
      isPlayerSlideActive: false,
      isPlayerLoadingRecord: false,
      isVolumeSliderVisible: false,
      recordUuid: '',
      clientUuid: '',
      fileName: '',
      connectionUuid: '',
    };
  },

  watch: {
    audioSourcePath: {
      handler() {
        this.isPlayerLoadingRecord = true;
        this.playerStopPlay();
        this.audioInstance = new Audio();
        this.audioInstance.src = this.audioSourcePath;
        this.audioInstance.onloadedmetadata = this.onPlayerLoadadeData;
        this.audioInstance.onerror = this.onPlayerError;
        this.audioInstance.ontimeupdate = this.onPlayerTimeUpdate;
      },
      immediate: true,
    },
    playerVolume() {
      this.audioInstance.volume = this.playerVolume / 100;
    },
  },

  mounted() {
    this.$EventBus.$on('RecordListItem/GET_RECORD_DETAILS', (connectionUuid) => {
      this.connectionUuid = connectionUuid;
    });
    // this.$EventBus.$on('RecordListItem/GET_RECORD_DETAILS', (record) => {
    //   this.recordUuid = record.recordUuid;
    //   this.clientUuid = record.clientUuid;
    //   this.fileName = record.fileName;
    // });
  },

  beforeDestroy() {
    this.$EventBus.$off('RecordListItem/GET_RECORD_DETAILS');
  },

  methods: {
    playerStartAutoPlay() {
      this.playerState = 'play';
      this.audioInstance.play();
    },
    onPlayerError() {
      this.isPlayerDisabled = true;
      this.isPlayerLoadingRecord = false;
    },
    onPlayerLoadadeData() {
      this.currentBuffer = 0;
      this.playerSliderWidth = 0;
      this.isPlayerLoadingRecord = false;
      this.showPopOverForStartPlayer();
      this.currentDuration = moment
        .utc(parseInt(this.audioInstance.currentTime, 10) * 1000)
        .format('HH:mm:ss');
      this.allDuration = moment
        .utc(parseInt(this.audioInstance.duration, 10) * 1000)
        .format('HH:mm:ss');
      this.isPlayerDisabled = false;

      this.audioInstance.onprogress = () => {
        for (let i = 0; i < this.audioInstance.buffered.length; i += 1) {
          if (this.audioInstance.buffered.start(this.audioInstance.buffered.length - 1 - i) < this.audioInstance.currentTime) {
            this.currentBuffer = (this.audioInstance.buffered.end(this.audioInstance.buffered.length - 1 - i) / this.audioInstance.duration) * 100;
            break;
          }
        }
      };

      if (this.autoPlay) {
        this.playerStartAutoPlay();
      }
    },
    onPlayerTimeUpdate() {
      if (this.isPlayerSlideActive) {
        return false;
      }
      this.currentDuration = moment
        .utc(parseInt(this.audioInstance.currentTime, 10) * 1000)
        .format('HH:mm:ss');

      this.playerSliderWidth = (this.audioInstance.currentTime / this.audioInstance.duration) * 100;
      return true;
    },
    showPopOverForStartPlayer() {
      // this.isMessageVisible = true;
      // setTimeout(() => {
      //   this.isMessageVisible = false;
      // }, 5000);
    },
    changeDurationPlayer(event, isClickEvent = false) {
      if (this.isPlayerDisabled) {
        return false;
      }

      if (isClickEvent || this.isPlayerSlideActive) {
        this.playerSliderWidth = 0;
        const partPercent = event.layerX / this.$refs.ShRecordPlayer__slider.getBoundingClientRect().width / 0.01;
        const currentPartSeconds = (partPercent / 100) * this.audioInstance.duration;

        this.currentDuration = moment
          .utc(parseInt(currentPartSeconds, 10) * 1000)
          .format('HH:mm:ss');

        this.audioInstance.currentTime = currentPartSeconds;
        this.playerSliderWidth = partPercent;
      }
      return true;
    },
    changeStatePlayerSlide(state) {
      if (this.isPlayerDisabled) {
        return false;
      }
      this.isPlayerSlideActive = state;
      return true;
    },
    setMutePlayer() {
      if (this.isPlayerDisabled) {
        return false;
      }

      if (this.playerVolume === 0) {
        this.playerVolume = this.playerVolumeCache;
        this.audioInstance.volume = this.playerVolume / 100;
      } else {
        this.playerVolumeCache = this.playerVolume;
        this.playerVolume = 0;
        this.audioInstance.volume = 0;
      }
      return true;
    },
    changeStatePlayerVolume(state) {
      if (this.isPlayerDisabled) {
        return false;
      }

      this.isVolumeSliderVisible = state;
      return true;
    },
    playerStopPlay() {
      if (this.isPlayerDisabled) {
        return false;
      }

      this.playerState = 'stop';
      this.audioInstance.pause();
      this.audioInstance.currentTime = 0;
      this.currentDuration = moment
        .utc(parseInt(this.audioInstance.currentTime, 10) * 1000)
        .format('HH:mm:ss');
      return true;
    },
    async playerDownloadRecord() {
      // const response = await this.$store.dispatch('record/getDetailsDownload', {
      //   record: this.recordUuid,
      //   client: this.clientUuid,
      //   action: 'download',
      // });
      const response = await this.$store.dispatch('record/getDetailsDownload', {
        connection: this.connectionUuid,
      });
      this.forceFileDownload(response, this.fileName);
    },
    forceFileDownload(response, fileName) {
      const element = document.createElement('a');
      element.setAttribute('href', response.data);
      element.setAttribute('download', `${fileName}.mp3`);
      if (document.createEvent) {
        const event = document.createEvent('MouseEvents');
        event.initEvent('click', true, true);
        element.dispatchEvent(event);
      } else {
        element.click();
      }
    },
    playerStartPlayOrPause() {
      if (this.isPlayerDisabled) {
        return false;
      }

      if (this.playerState === 'pause') {
        this.playerState = 'play';
        this.audioInstance.play();
      } else if (this.playerState === 'stop') {
        this.playerState = 'play';
        this.audioInstance.play();
      } else {
        this.playerState = 'pause';
        this.audioInstance.pause();
      }

      return true;
    },
  },
};
